import React from 'react';

class CompetitionPanel extends React.Component {

    render() {
        return (
            <div className="row">
                <p>I am a Competition panel</p>
            </div>
        );
    }
}

export default CompetitionPanel;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/CompetitionPanel.jsx
 **/